export default __webpack_public_path__ + "static/media/11.2ab97089.png";